export default {
    "news": "最新消息",
    "professor": "指導教授",
    "research": "研究方向",
    "member": "實驗室成員",
    "publication": "發表成果",
    "course": "開授課程",
    "en": "英文",
    "tw": "中文",
    "sidebar-name": "生醫奈米與",
    "sidebar-name2": "微系統晶片實驗室",
    "news-department": "國立清華大學動力機械工程學系",
    "news-labname": "生醫奈米與微系統晶片實驗室",
    "couese-recent": "近期開授課程",
    "couese-past": "過去開授課程",
    "professor-about": "關於",
    "professor-education": "學歷",
    "professor-experience": "經驗",
    "professor-research": "研究",
    "professor-reviewer": "審稿經驗",
    "professor-proposal-reviewer": "個人",
    "professor-publication-reviewer": "出版",
    "professor-conference-reviewer": "研討會",
    "professor-synergistic": "協同活動",
    "professor-award": "獲獎紀錄",
    "publication-papers": "期刊論文",
    "publication-conference": "國際會議",
    "publication-patent": "專利申請",
    "publication-symposium": "研討會",
    "patent-tw": "中華民國發明專利",
    "patent-us": "美國發明專利",
    "patent-jp": "日本發明專利",
    "patent-cn": "中國發明專利",
    "patent-eu": "歐洲發明專利",
    "patent-no": "申請編號",
    "patent-date": "申請日",
    "member-phd": "博士後",
    "member-collaboration": "產學合作",
    "member-assitant": "助理",
    "member-research-assitant": "研究助理",
    "member-administration-assitant": "行政助理",
    "member-ms": "碩士生",
    "member-ms-currently-studying": "在學中",
    "member-ms-graduted": "已畢業",
    "member-undergraduate": "專題生",
    "member-bs": "大學專題生",
    "member-junior": "高中專題生",
    "activity": "活動相簿",
    "activity-return": "返回",
}